import { render, staticRenderFns } from "./InstituteDropdown.vue?vue&type=template&id=18dd29aa"
import script from "./InstituteDropdown.vue?vue&type=script&lang=js"
export * from "./InstituteDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports